import React, {useEffect, useRef, useState} from 'react'

import t from 'helpers/I18n'

import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import BaseParagraph from "../../base-components/base-paragraph";
import InputField from "../../base-components/base-input";
import StepFooterAction from "../../base-components/step-footer-action";
import BottomSheet from '../../modals/bottom-sheet';
import nn from '../../../assets/png/NN.png'
import { HiOutlineLightBulb } from 'react-icons/hi'
// HiOutlineLightBulb

const NationalNumberStep = ({ _step_service, error, step_ID, step_URL, next_step, step_form, setDataToContext, getDataFromContext }) => {
    const form = useRef()
    const data = getDataFromContext(step_ID)
    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
   
    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
        const val = value.split('.').join('').split("-").join('')
        setDataToContext(step_ID, step_URL, name, val)
    }

    useEffect(()=> {
        setIsValid(isValidForm())
    }, [inputData])

    const action = () => {
         _step_service({step_ID, setIsLoading, next_step})
    }

    const isValidForm = () => {
        const data = getDataFromContext("dateOfBirth")
        const valToVlidate = inputData.national_reg_num
        const dateOfBirth = data ? data.birthday : "0"
        const d = dateOfBirth && dateOfBirth.split('').splice(2).join('').split('-').join('')
        const dd = valToVlidate && valToVlidate.split('-')[0].split('.').join('')

        if (data) {
            return  [...form.current.elements].every(element => {
                 return element.value !== "" && element.value !== " " && element.value.length >=15
            })  && !valToVlidate.includes("_") && d === dd
        }

        return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " "
        }) && !valToVlidate.includes("_") && d === dd
    }
    return (
        <>
            <StepsLoader step_ID={step_ID} loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('personal_infos.Personal_info_national_registration_number.title')}</h3>
                        <a className={"link"} onClick={() => setShowModal(true)}>
                            <HiOutlineLightBulb /> <span>{ t('personal_infos.Personal_info_national_registration_number.tool_tip')}</span> </a>
                        <br/>
                        <br/>
                        
                        {step_form.map(input => (
                            <InputField
                            label={t(input.label)}
                            value={inputData[input.id]}
                            name={input.id}
                            getInputValue={getInputValue}
                            key={input.id}
                            error={error}
                                isNNumber={true}
                               getDataFromContext={getDataFromContext}
                        />))}
                    </BaseParagraph>
                </form>
                <StepFooterAction caption={t('general.continue')} action={action} link={next_step} disabled={!isValid} />
                
                {showModal &&
                <BottomSheet
                    title={""}
                    close={() => {setShowModal(false)}}
                >
                    <BaseParagraph>
                        {/* <h3>{ t('personal_infos.Personal_info_national_registration_number.modal.title')}</h3> */}
                        <p>{ t('personal_infos.Personal_info_national_registration_number.modal.text')}</p>
                        <div className="img"><img src={nn} alt="" /></div>
                    </BaseParagraph>
                </BottomSheet>}
            </StepsLoader>
        </>
    )
}

NationalNumberStep.propTypes = {
    name: PropTypes.string
}

NationalNumberStep.defaultProps = {
    name: "email-step"
}


export default NationalNumberStep